import { useEffect, useState, useRef } from "react";
import imageYohan from "../photo/IMG_0058.jpg";
import { NavLink } from "react-router-dom";
import image9Hocopy from "../photo/image9Ho copy.jpg";
import image4Ho from '../photo/Evenement/image4Ho.jpg'
import image151Ho from "../photo/IMG_0075.jpg";
import ContactForm from "../components/ContactForm";

export const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeSection, setActiveSection] = useState(-1);

  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);
  // Initialiser les références
  useEffect(() => {
    sectionRefs.current = sectionRefs.current.slice(0, 4);
  }, []);
  
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const headerHeight = 80;
          const offsetPosition = element.getBoundingClientRect().top + window.pageYOffset - headerHeight;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  useEffect(() => {
    setIsVisible(true);
    
    // Créer l'observateur d'intersection
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const index = sectionRefs.current.findIndex(ref => ref === entry.target);
        if (index !== -1) {
          // Si la section est visible à plus de 60%, la considérer comme active
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            setActiveSection(index);
          }
        }
      });
    }, { 
      threshold: [0.2, 0.4, 0.6, 0.8], // Observer à différents niveaux de visibilité
      rootMargin: "-10% 0px" // Décaler légèrement pour améliorer l'effet
    });
    
    // Observer chaque section
    sectionRefs.current.forEach(section => {
      if (section) observer.observe(section);
    });
    
    return () => {
      sectionRefs.current.forEach(section => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);
  
  // Données des sections
  const sections = [
    {
      title: "Portraits",
      description: "Capturer l'essence de chaque personnalité, immortaliser des moments authentiques et émouvants.",
      image: imageYohan,
      alt: "Portraits",
      link: "/Portrait",
      button: "Découvrir"
    },
    {
      title: "Évènements",
      description: " L'évasion par la beauté naturelle, des panoramas à couper le souffle.",
      image: image151Ho,
      alt: "Évènements",
      link: "/Paysage",
      button: "Explorer"
    },
    {
      title: "Voitures",
      description: "Explorez des instants magiques où chaque image raconte une histoire unique et mémorable.",
      image: image9Hocopy,
      alt: "Voitures",
      link: "/Event",
      button: "Voir les photos"
    },
    {
      title: "Tournages",
      description: "Plongez dans l'univers créatif de notre photographe à travers des clips de tournage captivants.",
      image: image4Ho,
      alt: "Tournages",
      link: "/Tournage",
      button: "Voir les tournages"
    }
  ];
  
  return (
    <main className="min-h-screen bg-[#0B0B0F] text-white">
 

      
{/* Section À propos avec design innovant */}
<div id="about" className="relative py-20 overflow-hidden">
  {/* Arrière-plan animé */}
  <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-[#0B0B0F] opacity-80"></div>
  
  {/* Lignes décoratives animées */}
  <div className="absolute left-0 top-0 w-full h-1 bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-30 animate-pulse"></div>
  <div className="absolute right-0 top-0 h-full w-1 bg-gradient-to-b from-transparent via-gray-500 to-transparent opacity-30 animate-pulse" style={{animationDelay: '1s'}}></div>
  <div className="absolute left-0 bottom-0 w-full h-1 bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-30 animate-pulse" style={{animationDelay: '0.5s'}}></div>
  <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-transparent via-gray-500 to-transparent opacity-30 animate-pulse" style={{animationDelay: '1.5s'}}></div>

  {/* Contenu principal */}
  <div className="container mx-auto px-4 relative z-10">
    {/* En-tête avec animation */}
    <div className="text-center mb-16">
      <h1 className={`inline-block text-5xl md:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white via-gray-300 to-white pb-2 transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
        À PROPOS
      </h1>
      <div className={`h-1 w-0 bg-gradient-to-r from-transparent via-white to-transparent mx-auto transition-all duration-1500 ease-out ${isVisible ? 'w-40' : 'w-0'}`} style={{transitionDelay: '300ms'}}></div>
    </div>
    
    {/* Section photo et texte avec animation */}
    <div className="flex flex-col lg:flex-row items-center justify-between gap-12 mb-20">
      {/* Photo avec effet de profondeur */}
      <div className={`relative w-72 h-72 md:w-96 md:h-96 transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100 rotate-0' : 'translate-y-10 opacity-0 rotate-6'}`} style={{transitionDelay: '400ms'}}>
        <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-blue-400 to-cyan-500 opacity-20 blur-xl animate-pulse"></div>
        <div className="absolute -inset-0.5 rounded-full bg-gradient-to-tr from-blue-400 to-teal-500 opacity-30 blur-sm"></div>
        <div className="relative h-full w-full rounded-full overflow-hidden border-2 border-white/20">
          <img 
            src={imageYohan} 
            alt="Yohan Carrière" 
            className="w-full h-full object-cover transition-transform duration-700 ease-in-out hover:scale-110 hover:rotate-3"
          />
        </div>
        
        {/* Éléments décoratifs flottants */}
        <div className="absolute -top-6 -right-6 w-20 h-20 rounded-full border border-white/20 animate-spin-slow"></div>
        <div className="absolute -bottom-4 -left-4 w-12 h-12 rounded-full border border-white/20 animate-bounce-slow"></div>
        <div className="absolute top-1/2 -right-10 w-4 h-4 rounded-full bg-cyan-400/50 animate-pulse"></div>
      </div>
      
      {/* Texte biographique avec animation */}
      <div className="lg:w-1/2 space-y-8">
        <h2 className={`text-3xl md:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-300 transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{transitionDelay: '600ms'}}>
          Yohan Carrière
        </h2>
        <p className={`text-xl text-gray-300 font-light transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{transitionDelay: '700ms'}}>
          Photographe & Vidéographe
        </p>
        
        <div className={`space-y-6 transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{transitionDelay: '800ms'}}>
          <p className="text-gray-300 leading-relaxed">
            Je suis l'aîné de 3 enfants et je chemine dans ma croissance
            personnelle depuis un peu plus d'un an, explorant les profondeurs de
            mon être et les horizons infinis de mon potentiel. J'aime ce qui
            stimule tous mes sens, en particulier être immergé dans la nature.
          </p>
          <p className="text-gray-300 leading-relaxed">
            Sportif passionné, bouger est essentiel à ma vie. Que ce soit sur la
            glace pour le hockey, sur le parcours de golf, en courant sur les
            sentiers, en m'entraînant au gym, en escaladant des parois
            rocheuses, ou en dévalant les pentes en ski.
          </p>
        </div>
        
        {/* Tags animés */}
        <div className={`flex flex-wrap gap-3 pt-4 transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{transitionDelay: '900ms'}}>
          {['Photographie', 'Vidéographie', 'Nature', 'Sport', 'Voyage', 'Créativité'].map((tag, index) => (
            <span 
              key={tag} 
              className="px-4 py-2 rounded-full bg-white/10 text-sm text-white backdrop-blur-sm hover:bg-white/20 transition-all duration-300 transform hover:scale-105"
              style={{animationDelay: `${index * 100}ms`}}
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
    
    {/* Citation avec animation */}
    <div className={`max-w-4xl mx-auto my-20 transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{transitionDelay: '1000ms'}}>
      <div className="relative p-8 md:p-12 rounded-2xl bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-sm border border-white/10 shadow-xl">
        <div className="absolute -top-6 -left-6 text-6xl text-white/20">"</div>
        <div className="absolute -bottom-6 -right-6 text-6xl text-white/20">"</div>
        
        <p className="text-gray-200 text-lg md:text-xl italic text-center leading-relaxed">
          Je laisse libre cours à mon enfant intérieur pour qu'il s'exprime à
          travers l'art visuel, inspirant les autres à percevoir le monde
          différemment, avec curiosité et passion. Chaque photographie et chaque
          vidéo que je crée est une invitation à explorer, à ressentir et à
          s'émerveiller devant la beauté et la diversité qui nous entourent.
        </p>
        
        <div className="w-20 h-1 bg-gradient-to-r from-transparent via-white to-transparent mx-auto mt-8"></div>
      </div>
    </div>
    
    {/* Cartes de passions avec animation */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
      {[
        {
          title: "Passions",
          content: "Les voyages sont une de mes passions ardentes. Grand rêveur, je désire explorer le monde sous toutes ses facettes. Chaque destination est une nouvelle source d'inspiration pour mes créations visuelles.",
          delay: "1200ms",
          icon: "✈️"
        },
        {
          title: "Parcours",
          content: "Mon intérêt marqué pour les voitures m'a poussé à poursuivre des études en mécanique automobile. Cependant, c'est ma passion grandissante pour la photographie et la vidéographie qui a véritablement nourri mon côté créatif et artistique.",
          delay: "1400ms",
          icon: "🛣️"
        },
        {
          title: "Vision",
          content: "Mon aspiration la plus profonde est de susciter des émotions et de faire vivre des aventures à travers mes créations. Je souhaite permettre aux autres de ressentir chaque émotion capturée.",
          delay: "1600ms",
          icon: "👁️"
        }
      ].map((card, index) => (
        <div 
          key={card.title}
          className={`group relative overflow-hidden rounded-2xl bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-sm border border-white/10 p-6 transition-all duration-700 hover:shadow-2xl hover:border-white/20 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'}`}
          style={{transitionDelay: card.delay}}
        >
          <div className="absolute -right-10 -top-10 w-40 h-40 bg-gradient-to-br from-blue-400/20 to-cyan-400/20 rounded-full blur-xl group-hover:scale-150 transition-all duration-700"></div>
          
          <div className="relative z-10">
            <div className="text-3xl mb-4">{card.icon}</div>
            <h3 className="text-xl font-semibold mb-4 text-white">{card.title}</h3>
            <p className="text-gray-300 leading-relaxed">
              {card.content}
            </p>
            <div className="w-12 h-0.5 bg-white/30 mt-4 transition-all duration-300 group-hover:w-20 group-hover:bg-white/60"></div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
{/* Titre de la page avec effet de glitch moderne */}
<div id="portfolio" className="pt-16 pb-8 text-center relative overflow-hidden">
  {/* Effet de ligne animée */}
  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 via-cyan-400 to-teal-400 animate-pulse"></div>
  
  {/* Titre avec effet de texte moderne */}
  <div className="relative inline-block">
    <h1 className={`text-5xl md:text-7xl font-bold tracking-tight transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
      <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-gray-300 to-white">PORT</span>
      <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-cyan-400 to-teal-400">FOLIO</span>
    </h1>
    
    {/* Éléments décoratifs */}
    <div className="absolute -top-2 -right-2 w-4 h-4 rounded-full bg-cyan-400 animate-ping opacity-75"></div>
    <div className="absolute -bottom-2 -left-2 w-4 h-4 rounded-full bg-teal-400 animate-pulse opacity-75"></div>
  </div>
  
  {/* Séparateur animé */}
  <div className="relative h-1 w-24 mx-auto mt-8">
    <div className={`absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'}`}></div>
    <div className={`absolute inset-0 bg-gradient-to-r from-blue-400 via-cyan-400 to-teal-400 blur-sm transition-all duration-1000 delay-500 ${isVisible ? 'opacity-70 scale-x-100' : 'opacity-0 scale-x-0'}`}></div>
  </div>
</div>

{/* Section de cartes avec effet de parallaxe amélioré */}
<section className="w-full mx-auto py-12 flex flex-col pb-20 relative" style={{ marginTop: '10vh' }}>
  {/* Élément décoratif de fond */}
<div className="absolute top-1/4 left-1/4 w-1/2 h-1/2 bg-gradient-to-br from-blue-400/10 to-cyan-400/10 rounded-full blur-3xl"></div>
<div className="absolute bottom-1/4 right-1/4 w-1/2 h-1/2 bg-gradient-to-br from-cyan-400/10 to-teal-400/10 rounded-full blur-3xl"></div>
  {sections.map((section, index) => (
    <div 
      key={index}
      ref={el => sectionRefs.current[index] = el}
      className="w-full flex justify-center items-center"
      style={{ 
        height: '70vh',
        marginTop: index === 0 ? '0' : '-5vh',
        position: 'relative',
        zIndex: activeSection === index ? 50 : 10 - index,
      }}
    >
      <NavLink 
        to={section.link} 
        className={`group transition-all duration-1000 ease-in-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}
        style={{ 
          height: activeSection === index ? '85vh' : '70vh',
          width: activeSection === index ? '90%' : '75%',
          transition: 'all 1.2s cubic-bezier(0.25, 0.1, 0.25, 1)',
          position: 'relative',
        }}
      >
       {/* Effet de halo autour de la carte active */}
<div 
  className={`absolute inset-0 bg-gradient-to-br from-blue-400/20 via-cyan-400/20 to-teal-400/20 rounded-3xl blur-xl transition-opacity duration-1000 ${activeSection === index ? 'opacity-100' : 'opacity-0'}`}
  style={{ transform: 'scale(1.05)' }}
></div>
        <div className="bg-[#16161e] rounded-3xl overflow-hidden shadow-xl transform transition-all duration-500 hover:shadow-2xl border border-gray-800/50 backdrop-blur-sm h-full group-hover:border-white/20">
          <div className="relative h-full overflow-hidden">
            {/* Image avec effet de zoom amélioré */}
            <img
              src={section.image}
              alt={section.alt}
              className="w-full h-full object-cover opacity-80 transition-all duration-1000 ease-in-out transform group-hover:scale-110 group-hover:rotate-1"
            />
            
            {/* Overlay avec dégradé amélioré */}
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent opacity-70 group-hover:opacity-60 transition-opacity"></div>
            
            {/* Contenu avec animations séquentielles */}
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
              {/* Titre avec effet de glissement */}
              <h3 className="text-5xl font-bold mb-4 text-white transform transition-all duration-700 group-hover:-translate-y-2">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-300">{section.title}</span>
              </h3>
              
             {/* Ligne décorative */}
<div className="w-16 h-0.5 bg-gradient-to-r from-blue-400 to-cyan-400 mb-6 transform transition-all duration-700 group-hover:w-32"></div>
              {/* Description avec effet de fondu */}
              <p className="text-gray-200 mb-8 max-w-md transform transition-all duration-700 delay-100 group-hover:scale-105">
                {section.description}
              </p>
           {/* Bouton avec effet de brillance */}
<button className="relative px-8 py-4 bg-gradient-to-r from-blue-500 to-cyan-500 text-white rounded-lg overflow-hidden transition-all duration-500 transform hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/20">
  <span className="relative z-10 font-medium tracking-wide">{section.button}</span>
  <span className="absolute inset-0 bg-gradient-to-r from-blue-400 to-teal-400 opacity-0 group-hover:opacity-40 transition-opacity duration-700 transform -skew-x-12 group-hover:skew-x-12"></span>
</button>
            </div>
          </div>
        </div>
      </NavLink>
    </div>
  ))}
</section>
  {/* Section de contact */}
<section id="contact" className="py-20 relative overflow-hidden">
  <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-[#0B0B0F] opacity-80"></div>
  <div className="container mx-auto px-4 relative z-10">
    <div className="text-center mb-16">
      <h2 className="inline-block text-5xl md:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white via-gray-300 to-white pb-2">
        CONTACT
      </h2>
      <div className="h-1 w-40 bg-gradient-to-r from-transparent via-white to-transparent mx-auto mt-2"></div>
    </div>
    <div className="max-w-3xl mx-auto">
      <ContactForm />
    </div>
  </div>
</section>
    </main>
  );
};